import type { SVGProps } from 'react';
const SvgQuantity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M14 13.5H9M7 5H2m2.5 2.5v-5M3 13.5l10-10"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgQuantity;
